import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { FaFlag } from "react-icons/fa6";
import { LuDownload } from "react-icons/lu";
import { useState, useEffect } from "react";
import { BeatLoader } from "react-spinners";
import { SocialIcon } from "react-social-icons";
import toast, { Toaster } from "react-hot-toast";
import { Drawer } from "@material-tailwind/react";
import { IoSearch, IoSend, IoShareSocial } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { MdOutlineSpeed, MdSpeed } from "react-icons/md";
import { IoMdClose, IoIosArrowForward } from "react-icons/io";
import { getReportReasons, submitPostReport } from "../../redux/ApiSlice/ReportSlice";
import { downloadVideoFile } from "../../redux/ApiSlice/DownloadVideoSlice";
import { FaCheckCircle, FaHeartBroken, FaRegCopy } from "react-icons/fa";
import { getRecentFriendList, shareVideoThoughMessage } from "../../redux/ApiSlice/ShareSlice";
import { postNotInterested, removeNotInterestedPost } from "../../redux/ApiSlice/HomePageVideoSlice";


export default function Share({ closeDrawerBottom, openBottom, videoUrl, download_enabled, postId, playbackSpeed, setPlaybackSpeed, createdById, onReportSuccess }) {
    const [downloaded, setDownloaded] = useState(false);
    const [copying, setCopying] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [userMessage, setUserMessage] = useState("");
    const [openSpeedDrawer, setOpenSpeedDrawer] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [reportPost, setReportPost] = useState(false);
    const [reportStep, setReportStep] = useState("reason");
    const [selectedReason, setSelectedReason] = useState(null);
    const [selectedSubReason, setSelectedSubReason] = useState("");
    const [reportNote, setReportNote] = useState("");
    const [reportLoading, setReportLoading] = useState(false);
    const [postReportSuccess, setPostReportSuccess] = useState(false);
    const [reportError, setReportError] = useState("");
    const [showToast, setShowToast] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { User_profile } = useSelector((state) => state.AccountProfile);
    const { recentFriends = [], loading } = useSelector((state) => state.SharePost || {});
    const { reportReasons = [], reportReasonsLoading } = useSelector((state) => state.Report);
    const isOwnPost = createdById && User_profile?.id === createdById;
    const isReportSubmitDisabled = reportLoading || !selectedReason || (selectedReason?.sub_reasons?.length > 0 && !selectedSubReason);

    useEffect(() => {
        if (openBottom) {
            dispatch(getRecentFriendList());
        }
    }, [dispatch, openBottom]);

    const handleSelectUser = (user) => {
        setSelectedUsers((prev) => {
            if (prev.some((u) => u.id === user.id)) {
                return prev.filter((u) => u.id !== user.id);
            } else {
                return [...prev, user];
            }
        });
    };

    const speedOptions = [
        { value: 2, label: "2x" },
        { value: 1.5, label: "1.5x" },
        { value: 1, label: "Normal" },
        { value: 0.5, label: "0.5x" },
    ];

    const socialLinks = [
        { url: "https://www.instagram.com", label: "Instagram" },
        { url: "https://x.com", label: "X" },
        { url: "https://www.snapchat.com", label: "Snapchat" },
        { url: "https://www.facebook.com", label: "Facebook" },
        { url: "https://www.reddit.com", label: "Reddit" },
        { url: "https://whatsapp.com", label: "WhatsApp" },
    ];

    const handleSpeedSelection = (speed) => {
        setPlaybackSpeed(speed);
        toast.success(`Speed: ${speed === 1 ? "Normal" : speed + "x"}`);
    };

    // Show all friends, only filter by search term
    const filteredFriends = (recentFriends || [])
        .filter(friend =>
            friend.full_name.toLowerCase().includes(searchTerm.toLowerCase())
        );

    const copyToClipboard = async () => {
        try {
            setCopying(true);
            await navigator.clipboard.writeText(`${process.env.REACT_APP_MAIN_URL}v/${postId}`);
            toast.success("URL copied to clipboard!");
        } catch (error) {
            console.error("Failed to copy URL:", error);
            toast.error("Failed to copy URL");
        } finally {
            setCopying(false);
        }
    };

    const downloadVideo = async (videoUrl) => {
        if (!postId) {
            toast.error("No post ID provided");
            return;
        }

        try {
            toast.success("Preparing download...");
            setDownloaded(true);

            const filename = `video_${postId}.mp4`;

            // Method 1: Try backend proxy download (BEST - bypasses CORS)
            try {
                const result = await dispatch(downloadVideoFile(postId));

                if (result.payload && result.payload.blob) {
                    const blob = result.payload.blob;
                    const blobUrl = window.URL.createObjectURL(blob);
                    const downloadFilename = result.payload.filename || filename;

                    const a = document.createElement('a');
                    a.href = blobUrl;
                    a.download = downloadFilename;
                    a.style.display = 'none';
                    document.body.appendChild(a);
                    a.click();

                    setTimeout(() => {
                        document.body.removeChild(a);
                        window.URL.revokeObjectURL(blobUrl);
                    }, 100);

                    toast.success("Download completed!");
                    return;
                } else {
                    throw new Error('Backend proxy download failed');
                }
            } catch (proxyError) {

                // Method 2: Try direct fetch with CORS
                try {
                    const response = await fetch(videoUrl, {
                        method: 'GET',
                        mode: 'cors',
                        redirect: 'follow',
                        credentials: 'omit'
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP ${response.status}`);
                    }

                    const blob = await response.blob();
                    const blobUrl = window.URL.createObjectURL(blob);

                    const a = document.createElement('a');
                    a.href = blobUrl;
                    a.download = filename;
                    a.style.display = 'none';
                    document.body.appendChild(a);
                    a.click();

                    setTimeout(() => {
                        document.body.removeChild(a);
                        window.URL.revokeObjectURL(blobUrl);
                    }, 100);

                    toast.success("Download completed!");
                    return;

                } catch (corsError) {

                    // Method 3: Direct link download (last resort)
                    const a = document.createElement('a');
                    a.href = videoUrl;
                    a.download = filename;
                    a.style.display = 'none';
                    a.target = '_blank';
                    a.rel = 'noopener noreferrer';

                    document.body.appendChild(a);
                    a.click();

                    setTimeout(() => {
                        document.body.removeChild(a);
                    }, 100);

                    toast.info("Download started! If it doesn't work, right-click the video and select 'Save video as...'", {
                        duration: 5000
                    });
                }
            }

        } catch (error) {
            console.error("Error downloading the video:", error);
            toast.error("Unable to download. Please try: Right-click video → Save video as...");
            setDownloaded(false);
        }
    };

    const handleSend = async () => {
        if (!postId || selectedUsers.length === 0) {
            toast.error("Select at least one user and provide a post ID.");
            return;
        }
        setShowToast(true);
        const payload = {
            post_id: postId,
            receiver_ids: selectedUsers.map((u) => u.id),
            custom_message: userMessage || undefined,
        };
        try {
            await dispatch(shareVideoThoughMessage(payload)).unwrap();
            toast.success(`Sent to ${selectedUsers.map(u => u.full_name).join(", ")}`);
            setSelectedUsers([]);
            setUserMessage("");
            setTimeout(() => {

                setShowToast(false);
            }, 1000);

        } catch (error) {
            toast.error("Failed to send message");
        }
    };

    const handleNotInterested = async () => {
        if (!postId) return;
        dispatch(removeNotInterestedPost(postId));
        closeDrawerBottom();
        try {
            await dispatch(postNotInterested(postId)).unwrap();
            toast.success("Got it! We'll show you less of this.");
        } catch {
            toast.error("Something went wrong. Please try again.");
        }
    };

    const handleOpenReportDrawer = () => {
        closeDrawerBottom();
        dispatch(getReportReasons());
        setReportPost(true);
        setReportStep("reason");
        setSelectedReason(null);
        setSelectedSubReason("");
        setReportNote("");
        setPostReportSuccess(false);
        setReportError("");
    };

    const handleCloseReportDrawer = () => {
        setReportPost(false);
        setReportStep("reason");
        setSelectedReason(null);
        setSelectedSubReason("");
        setReportNote("");
        setReportError("");
        setPostReportSuccess(false);
    };

    const handleClosePostReportSuccess = () => {
        handleCloseReportDrawer();
        setPostReportSuccess(false);
    };

    const handleReasonSelect = (reasonOption) => {
        setSelectedReason(reasonOption);
        setSelectedSubReason("");
        setReportNote("");
        setReportStep("detail");
        setReportError("");
    };

    const handleBackToReasons = () => {
        setReportStep("reason");
        setSelectedSubReason("");
        setReportNote("");
        setReportError("");
    };

    const handleSubmitReportPost = async () => {
        if (!postId) {
            toast.error("No post ID provided");
            return;
        }

        if (!selectedReason) {
            toast.error("Please select a reason for reporting");
            return;
        }

        if (selectedReason.sub_reasons?.length > 0 && !selectedSubReason) {
            toast.error("Choose a sub-reason to continue");
            return;
        }

        const requestData = {
            reason: selectedReason.code,
            ...(selectedSubReason && { sub_reason: selectedSubReason }),
            ...(reportNote.trim() && { user_comment: reportNote.trim() }),
        };

        try {
            setReportLoading(true);
            setReportError("");
            const result = await dispatch(submitPostReport({ postId, data: requestData }));

            if (submitPostReport.fulfilled.match(result)) {
                setReportError("");
                if (typeof onReportSuccess === "function") {
                    onReportSuccess();
                    handleCloseReportDrawer();
                } else {
                    setPostReportSuccess(true);
                }
                toast.success("Post reported successfully");
                navigate("/report-center");
            } else if (submitPostReport.rejected.match(result)) {
                const errorMessage = result.payload?.message || result.payload?.detail || "Failed to report post";
                setReportError(errorMessage);
                setPostReportSuccess(false);
            }
        } catch (error) {
            const fallbackMessage = error?.response?.data?.message || error?.message || "Failed to report post";
            setReportError(fallbackMessage);
            setPostReportSuccess(false);
        } finally {
            setReportLoading(false);
        }
    };

    const reportDrawerSize = postReportSuccess ? 220 : 540;

    return (
        <>
            {/* Share post */}
            <Drawer
                size={selectedUsers.length > 0 ? 250 : 200}
                placement="bottom"
                open={openBottom}
                style={{ zIndex: 1 }}
                onClose={closeDrawerBottom}
                className={`absolute dark:bg-[#1E1D21] w-full rounded-t-2xl ${!openBottom && "hidden"}`}
            >
                {/* Action buttons — horizontal scroll */}
                <div
                    style={{ WebkitOverflowScrolling: 'touch', touchAction: 'pan-x', msOverflowStyle: 'none', scrollbarWidth: 'none' }}
                    className="py-3 overflow-x-auto overflow-y-hidden"
                >
                    <div className="flex gap-2 px-3 w-full justify-between">
                        {[
                            { icon: <FaRegCopy className={`text-[18px] text-gray-700 dark:text-gray-300 ${copying ? "animate-pulse" : ""}`} />, label: "Copy Link", onClick: copyToClipboard, show: true },
                            { icon: <FaFlag className="text-[16px] text-gray-700 dark:text-gray-300" />, label: "Report", onClick: handleOpenReportDrawer, show: !isOwnPost },
                            { icon: <MdSpeed className="text-[20px] text-gray-700 dark:text-gray-300" />, label: "Video Speed", onClick: () => { closeDrawerBottom(); setOpenSpeedDrawer(true); }, show: true },
                            { icon: <LuDownload className="text-[20px] text-gray-700 dark:text-gray-300" />, label: "Save", onClick: () => downloadVideo(videoUrl), show: !!download_enabled },
                            { icon: <FaHeartBroken className="text-[18px] text-gray-700 dark:text-gray-300" />, label: "Not Interested", onClick: handleNotInterested, show: true },
                        ].filter(btn => btn.show).map((btn, i) => (
                            <div key={i} className="flex flex-col items-center gap-1 cursor-pointer" onClick={btn.onClick ?? undefined}>
                                <div className="w-[45px] h-[45px] rounded-full bg-gray-100 dark:bg-[#333333] flex items-center justify-center">
                                    {btn.icon}
                                </div>
                                <span className="text-[8px] text-gray-700 dark:text-gray-300 font-semibold text-center whitespace-nowrap">{btn.label}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Search / Message input */}
                <div className="px-3 pb-2">
                    <div className="relative">
                        <input
                            type="text"
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                            placeholder="Message to..."
                            className="w-full py-2 pl-4 pr-10 rounded-full outline-none text-[13px] text-black dark:text-white bg-gray-200 dark:bg-[#333333]"
                        />
                        <IoSearch className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-700 dark:text-white text-[20px]" />
                    </div>
                </div>

                {/* Friends — single scrollable row */}
                {filteredFriends && filteredFriends.length > 0 ? (
                    <div className="py-1 pl-3 w-full">
                        <Carousel
                            responsive={{
                                all: { breakpoint: { max: 4000, min: 0 }, items: 5.5, slidesToSlide: 1 }
                            }}
                            swipeable
                            draggable
                            smooth={true}
                            infinite={false}
                            arrows={false}
                            partialVisible
                        >
                            {filteredFriends.map((data, index) => (
                                <div key={data.id || index}
                                    className="flex flex-col items-center cursor-pointer relative w-[46px] mx-1"
                                    onClick={() => handleSelectUser(data)}
                                >
                                    <img
                                        alt={`img${index}`}
                                        src={data.avatar_url}
                                        className={`h-[46px] w-[46px] object-cover rounded-full ${selectedUsers.some((u) => u.id === data.id) ? "border-2 border-[#004568] p-0.5" : "border border-gray-300 dark:border-gray-700"}`}
                                    />
                                    <p className="text-[8px] text-black dark:text-white font-semibold truncate w-full text-center mt-0.5">
                                        {data.full_name.split(" ")[0]}
                                    </p>
                                    {selectedUsers.some((u) => u.id === data.id) && (
                                        <FaCheckCircle className="absolute top-0 right-0 text-[#004568] bg-white rounded-full text-[14px]" />
                                    )}
                                </div>
                            ))}
                        </Carousel>
                    </div>
                ) : (
                    !loading && <p className="text-[12px] text-gray-500 py-3 px-3">No friends found</p>
                )}

                {/* Social icons — single scrollable row */}
                {/* <div className="py-1 pl-3 w-full">
                    <Carousel
                        responsive={{
                            all: { breakpoint: { max: 4000, min: 0 }, items: 5.5, slidesToSlide: 1 }
                        }}
                        swipeable
                        draggable
                        smooth={true}
                        infinite={false}
                        arrows={false}
                        partialVisible
                    >
                        {socialLinks.map(({ url, label }) => (
                            <div key={url} className="flex flex-col items-center gap-0.5 w-[46px] mx-1">
                                <SocialIcon
                                    url={url}
                                    title={label}
                                    style={{ height: 46, width: 46 }}
                                    className="cursor-pointer"
                                />
                                <span className="text-[8px] text-gray-700 dark:text-gray-300 font-semibold text-center truncate w-full">{label}</span>
                            </div>
                        ))}
                    </Carousel>
                </div> */}

                {/* Send bar — visible when users are selected */}
                {selectedUsers.length > 0 && (
                    <div className="flex items-center px-2 py-2 border-t border-b border-gray-300 dark:border-gray-800 bg-white dark:bg-[#1E1D21]">
                        <div className="relative w-full">
                            <input
                                type="text"
                                value={userMessage}
                                placeholder="Send message to selected users..."
                                onChange={(e) => setUserMessage(e.target.value)}
                                className="w-full py-2 px-4 rounded-full outline-none text-[13px] text-black dark:text-white bg-gray-200 dark:bg-[#333333]"
                            />
                            <IoSend
                                onClick={handleSend}
                                className="absolute top-1/2 right-3 transform -translate-y-1/2 text-[16px] cursor-pointer text-gray-700 dark:text-white"
                            />
                        </div>
                    </div>
                )},
            </Drawer>

            {/* Playback speed */}
            {openSpeedDrawer && (
                <Drawer
                    size={130}
                    placement="bottom"
                    open={openSpeedDrawer}
                    onClose={() => setOpenSpeedDrawer(false)}
                    className="absolute w-full rounded-t-2xl bg-white dark:bg-gray-900"
                    style={{ zIndex: 2 }}
                >
                    <div className="flex flex-col w-full px-5 pt-4 pb-6 gap-5">
                        {/* Header */}
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-2">
                                <MdOutlineSpeed className="text-[20px] text-black dark:text-gray-100" />
                                <h2 className="text-sm font-semibold text-black dark:text-gray-100 tracking-wide">Playback Speed</h2>
                            </div>
                            <button
                                type="button"
                                onClick={() => setOpenSpeedDrawer(false)}
                                className="flex items-center justify-center h-7 w-7 rounded-full bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300"
                            >
                                <IoMdClose className="text-[14px]" />
                            </button>
                        </div>

                        {/* Segmented control */}
                        {(() => {
                            const reversedOptions = speedOptions.slice().reverse();
                            const selectedIndex = reversedOptions.findIndex(o => o.value === playbackSpeed);
                            return (
                                <div className="relative flex w-full rounded-full bg-gray-100 dark:bg-gray-800 border border-gray-300 dark:border-gray-700 p-1 overflow-hidden">
                                    {/* Animated sliding pill */}
                                    <div
                                        className="absolute top-1 bottom-1 rounded-full bg-black dark:bg-white shadow-sm"
                                        style={{
                                            width: "calc(25% - 2px)",
                                            left: `calc(4px + ${selectedIndex} * (25% - 2px))`,
                                            transition: "left 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                                        }}
                                    />
                                    {reversedOptions.map(({ value, label }) => (
                                        <button
                                            key={value}
                                            type="button"
                                            onClick={() => handleSpeedSelection(value)}
                                            aria-pressed={playbackSpeed === value}
                                            className={`relative z-10 flex-1 py-2 text-center text-[13px] font-semibold transition-colors duration-200 ${playbackSpeed === value
                                                ? "text-white dark:text-black"
                                                : "text-gray-800 dark:text-gray-400"
                                                }`}
                                        >
                                            {label}
                                        </button>
                                    ))}
                                </div>
                            );
                        })()}
                    </div>
                </Drawer>
            )}

            {/* Report post */}
            {reportPost && (
                <Drawer
                    size={reportDrawerSize}
                    placement="bottom"
                    open={reportPost}
                    onClose={handleCloseReportDrawer}
                    className="absolute w-full rounded-t-2xl bg-white dark:bg-gray-900 max-h-[90vh] shadow-2xl"
                    style={{ zIndex: 3 }}
                >
                    <div className={`relative flex flex-col ${postReportSuccess ? "h-auto max-h-[70vh]" : "h-full max-h-[80vh]"}`}>
                        <div className="relative flex items-center justify-center px-4 pt-3 pb-2">
                            {reportStep === "detail" && !postReportSuccess && (
                                <IoIosArrowForward
                                    onClick={handleBackToReasons}
                                    className="absolute left-4 top-4 cursor-pointer rotate-180 text-[20px] text-gray-800 dark:text-gray-100"
                                />
                            )}
                            {reportStep !== "detail" &&
                                <IoMdClose
                                    onClick={handleCloseReportDrawer}
                                    className="absolute right-4 top-3 cursor-pointer text-[20px] text-gray-800 dark:text-gray-100"
                                />
                            }
                        </div>

                        {!postReportSuccess && reportStep === "reason" && (
                            <div className="flex h-full flex-col overflow-y-auto pb-6">
                                <div className="px-4 pt-1 pb-4 text-center space-y-1">
                                    <h2 className="text-[16px] font-semibold text-black dark:text-white">Report post</h2>
                                    <p className="text-[11px] text-gray-600 dark:text-gray-300">
                                        Reports are confidential. The person who posted won't know you reported it.
                                    </p>
                                </div>

                                <div className="border-t border-b border-gray-200 dark:border-gray-800 divide-y divide-gray-200 dark:divide-gray-800">
                                    {reportReasonsLoading ? (
                                        <div className="flex justify-center items-center py-8">
                                            <BeatLoader size={8} color={"#6b7280"} />
                                        </div>
                                    ) : (
                                        reportReasons.map((item) => (
                                            <button
                                                key={item.code}
                                                type="button"
                                                onClick={() => handleReasonSelect(item)}
                                                className="flex w-full items-center justify-between px-5 py-2.5 text-left hover:bg-gray-50 dark:hover:bg-gray-800"
                                            >
                                                <span className="text-[12px] font-medium text-gray-900 dark:text-gray-100">{item.label}</span>
                                                <IoIosArrowForward className="text-[16px] text-gray-400" />
                                            </button>
                                        ))
                                    )}
                                </div>

                                <p className="mt-4 px-6 text-center text-[11px] leading-5 text-gray-500 dark:text-gray-400">
                                    Learn more about our <span onClick={() => navigate("/community-guidelines")} className="text-blue-500 underline cursor-pointer">Community Guidelines</span>.
                                </p>
                            </div>
                        )}

                        {!postReportSuccess && reportStep === "detail" && selectedReason && (
                            <div className="flex h-full flex-col overflow-y-auto pb-4">
                                <div className="px-4 pt-2 pb-3 text-center space-y-1">
                                    <h3 className="text-[14px] font-semibold text-black dark:text-white">{selectedReason.label}</h3>
                                    <p className="text-[12px] text-gray-600 dark:text-gray-300">
                                        Tell us more so we can review this post.
                                    </p>
                                </div>

                                <div className="flex flex-col gap-3 px-4">
                                    {selectedReason.sub_reasons?.length > 0 ? (
                                        <div className="overflow-hidden rounded-xl border border-gray-500 dark:border-gray-800 divide-y divide-gray-500 dark:divide-gray-800 bg-white dark:bg-gray-900">
                                            {selectedReason.sub_reasons.map((sub) => (
                                                <button
                                                    key={sub.code}
                                                    type="button"
                                                    onClick={() => setSelectedSubReason(sub.code)}
                                                    className="flex w-full items-center justify-between px-4 py-3 text-left hover:bg-gray-50 dark:hover:bg-gray-800"
                                                >
                                                    <span className="text-[12px] text-gray-900 dark:text-gray-100">{sub.label}</span>
                                                    <span className={`flex h-4 w-4 items-center justify-center rounded-full border ${selectedSubReason === sub.code ? "border-gray-900 dark:border-gray-100" : "border-gray-500 dark:border-gray-700"}`}>
                                                        <span className={`h-2 w-2 rounded-full ${selectedSubReason === sub.code ? "bg-gray-900 dark:bg-gray-100" : "bg-transparent"}`} />
                                                    </span>
                                                </button>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="rounded-xl border border-gray-200 dark:border-gray-800 bg-gray-50 p-3 text-[12px] text-gray-600 dark:bg-gray-800 dark:text-gray-200">
                                            No additional categories for this reason. Add optional context below.
                                        </div>
                                    )}

                                    <div className="rounded-xl border border-gray-200 dark:border-gray-800 bg-gray-50 dark:bg-gray-800 p-3">
                                        <textarea
                                            value={reportNote}
                                            maxLength={250}
                                            placeholder="Share anything that might help us understand the issue (optional)"
                                            onChange={(e) => setReportNote(e.target.value)}
                                            className="h-[90px] w-full resize-none bg-transparent text-[13px] text-gray-900 placeholder-gray-500 outline-none dark:text-gray-100 dark:placeholder-gray-400"
                                        />
                                        <div className="mt-1 flex items-center justify-between text-[11px] text-gray-500 dark:text-gray-400">
                                            {reportError && <span className="text-red-600">{reportError}</span>}
                                            <span>{reportNote.length}/250</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-auto flex gap-3 px-4 pt-4 pb-3">
                                    <button
                                        type="button"
                                        onClick={handleCloseReportDrawer}
                                        className="flex-1 rounded-xl border border-gray-300 bg-white py-2 text-[14px] font-semibold text-gray-800 shadow-sm transition hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100 dark:hover:bg-gray-800"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        disabled={isReportSubmitDisabled}
                                        onClick={handleSubmitReportPost}
                                        className={`flex flex-1 items-center justify-center rounded-xl py-2 text-[14px] font-semibold transition ${isReportSubmitDisabled ? "cursor-not-allowed bg-gray-200 text-gray-500 dark:bg-gray-800 dark:text-gray-500" : "bg-red-600 text-white hover:bg-red-700"}`}
                                    >
                                        {reportLoading ? <BeatLoader size={10} color={"#fff"} loading={reportLoading} /> : "Submit report"}
                                    </button>
                                </div>

                                <p className="px-6 text-center text-[11px] text-gray-500 dark:text-gray-400">
                                    Reports are confidential. The person who posted won't know you reported it.
                                </p>
                            </div>
                        )}

                        {postReportSuccess && (
                            <div className="flex flex-col items-center justify-center gap-4 px-6 pb-6 pt-2 text-center">
                                <p className="text-[20px] font-semibold text-gray-900 dark:text-white">
                                    Thanks for letting us know
                                </p>
                                <p className="text-[11px] text-gray-700 dark:text-gray-300">
                                    We'll review this post and take action if it violates our guidelines.
                                    You may not hear back, but your report helps keep the community safe.
                                </p>
                                <button
                                    onClick={handleClosePostReportSuccess}
                                    className="w-full bg-gray-800 text-white rounded-xl py-2"
                                >
                                    Done
                                </button>
                                <p className="px-6 text-center text-[11px] leading-5 text-gray-500 dark:text-gray-400">
                                    Learn more about our <span className="text-blue-500 underline cursor-pointer">Community Guidelines</span>.
                                </p>
                            </div>
                        )}
                    </div>
                </Drawer>
            )}
        </>
    );
}